import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { ReduxState } from '~/store';
import AnimatingDots from './AnimatingDots';

const LoaderOverlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const FullPageLoader = () => {
  const isLoading = useSelector((state: ReduxState) => state.app.loader);

  return (
    <LoaderOverlay isVisible={isLoading}>
      <LoaderContainer>
        <AnimatingDots color="white" successiveDelay={0.2} />
      </LoaderContainer>
    </LoaderOverlay>
  );
};

export default FullPageLoader;
